const clientBusinessEventMealSlot = (json: IClientBusinessEventMealSlot): IClientBusinessEventMealSlotModel => {
	const { meal_id, meal_type, variant_id, meal_name, date } = json

	return {
		mealID: meal_id,
		mealType: meal_type,
		variantID: variant_id,
		mealName: meal_name,
		date,
	}
}

const clientBusinessEventMealDay = (json: IClientBusinessEventMealDay): IClientBusinessEventMealDayModel => {
	const { date, meals } = json

	return { date, meals: meals.map(clientBusinessEventMealSlot) }
}

const clientBusinessEventPurchaseItem = (
	json: IClientBusinessEventPurchaseItem,
): IClientBusinessEventPurchaseItemModel => {
	const {
		cart_item_id,
		item_name,
		diet_id,
		diet_label,
		kcal,
		price,
		diet_nickname,
		friendly_id,
		start_date,
		end_date,
		days_count,
		delivery_address,
		meal_ids,
		meal_types,
		variant_ids,
		meal_names,
		meals_by_day,
	} = json

	return {
		kcal,
		price,
		cartItemID: cart_item_id,
		itemName: item_name,
		dietID: diet_id,
		dietLabel: diet_label,
		dietNickname: diet_nickname,
		friendlyID: friendly_id,
		startDate: start_date,
		endDate: end_date,
		daysCount: days_count,
		deliveryAddress: delivery_address,
		mealIDs: meal_ids,
		mealTypes: meal_types,
		variantIDs: variant_ids,
		mealNames: meal_names,
		mealsByDay: meals_by_day.map(clientBusinessEventMealSlot),
	}
}

const clientBusinessEventChange = (json: IClientBusinessEventChange): IClientBusinessEventChangeModel => {
	const { field, before, after } = json

	return {
		field: keyToCamelCase(field),
		before,
		after,
	}
}

const clientBusinessEventPayload = (
	json: IClientBusinessEventPayload | null | undefined,
): IClientBusinessEventPayloadModel => {
	if (!json) return {}

	const { items, meals_by_day, previous_meals_by_day, new_meals_by_day, ...rest } = json
	const mapped: IClientBusinessEventPayloadModel = {}

	for (const [key, value] of Object.entries(rest)) {
		mapped[keyToCamelCase(key)] = value as TClientBusinessEventJson
	}

	if (items) {
		mapped.items = items.map(clientBusinessEventPurchaseItem)
	}

	if (meals_by_day) {
		mapped.mealsByDay = meals_by_day.map(clientBusinessEventMealDay)
	}

	if (previous_meals_by_day) {
		mapped.previousMealsByDay = previous_meals_by_day.map(clientBusinessEventMealDay)
	}

	if (new_meals_by_day) {
		mapped.newMealsByDay = new_meals_by_day.map(clientBusinessEventMealDay)
	}

	return mapped
}

export const ClientBusinessEvent = (json: IClientBusinessEvent): IClientBusinessEventModel => {
	const { id, entity_id, action, channel, date, description, editor, changes, payload } = json

	return {
		id,
		action,
		channel,
		description,
		editor,
		entityID: entity_id,
		date: new Date(date),
		changes: changes.map(clientBusinessEventChange),
		payload: clientBusinessEventPayload(payload),
	}
}
